<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <WithdrawRecordsTable/>
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
  import WithdrawRecordsTable from './WithdrawRecordsTable.vue'

  export default {
    name: 'withdraw-records',
    components: {WithdrawRecordsTable}
  }
</script>



// WEBPACK FOOTER //
// src/views/payment/records/withdraw/WithdrawRecords.vue